import { AHV_IV_EO_RATE, DEFAULT_VACATION_PERCENTAGE_4W } from "@/config/constants";

export type RGB = [number, number, number];

export const PDF_CONFIGS = {
  HOURLY_RATE: 50,
  AHV_IV_EO_RATE,
  BREAK_THRESHOLD_HOURS: 5.5,
  BREAK_DURATION_MINUTES: 15,
  YELLOW_LINE_COLOR: [242, 183, 5] as RGB,
  HEADER_BG_COLOR: [220, 220, 220] as RGB,
  VACATION_PERCENTAGE: DEFAULT_VACATION_PERCENTAGE_4W,
};

export const TABLE_COLUMN_WIDTHS = {
  DATE: 25,
  START_TIME: 20,
  END_TIME: 20,
  BREAK: 20,
  HOURS: 15,
  AMOUNT: 25
};
